<template>
  <div
    class="header-back-navigation"
    data-sentry-unmask
  >
    <component
      :is="component"
      :to="to"
      class="btn btn-link"
      @click="handleClick"
    >
      <app-icon name="arrow-narrow-left" />
      {{ label }}
    </component>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps({
  label: {
    type: String,
    default: 'Go back',
  },
  to: {
    type: [String, Object],
    default: null,
  },
  onBack: {
    type: Function,
    default: null,
  },
});

const router = useRouter();

const component = computed(() => {
  return props.to ? 'router-link' : 'button';
});

const handleClick = () => {
  if (props.onBack) {
    props.onBack();
  } else {
    router.back();
  }
};
</script>

<style>
@reference '@/assets/main.css';

.header-back-navigation {
  @apply sticky top-0 pt-6 px-8 -m-8 mb-8 bg-gray-cool-50 z-10;
  width: calc(100% + var(--spacing) * 16);
  box-shadow: 0 24px 16px 0 var(--color-gray-cool-50);
}
</style>
